import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const ElomradePage = lazy(() => import("@/pages/elpriser/ElomradePage"));

export const Route = createFileRoute("/elpriser/elomrade-1")({
  // Spotpriserna hämtas på servern så att tabeller och nyckeltal finns i HTML:en.
  loader: spotPriceLoader,
  head: () => seoHead("/elpriser/elomrade-1"),
  component: () => <ElomradePage />,
});
